import React, {useEffect} from "react";
import { Col, Row } from "react-bootstrap";
import shape from "../../static/shape.svg";
import ql1 from '../../static/Account/ql-1.png';
import ql2 from '../../static/Account/ql-2.png';

import ar1 from '../../static/Account/ar-1.png';
import ar2 from '../../static/Account/ar-2.png';

import sp1 from '../../static/Account/sp-1.png';
import sp2 from '../../static/Account/sp-2.png';
import sp3 from '../../static/Account/sp-3.png';
import { Link, useNavigate} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getLocalData } from "../../utils/localStorage";

import { getAllOrders } from "../../services/OrderService";
import {updateOrders} from '../../redux/orderSlice'
import { updateUser } from "../../redux/userSlice";
import Home from "../SvgComponents/Solid/Home";
import Chat from "../SvgComponents/Solid/Chat";
import Wish from "../SvgComponents/Solid/Wish";
import Cart from "../SvgComponents/Solid/Cart";
import Pp from "../SvgComponents/Solid/Pp";
import Tc from "../SvgComponents/Solid/Tc";


import Cartee from '../../static/Solid/Cart.svg';
import AddAddress from "../SvgComponents/Solid/AddAddress";
function Profile() {
  const noOfProductsInWishlist = useSelector(
    (state) => state.cart.noOfProductsInWishList
  );

  const userData = useSelector((state) => state.user.userData);
  const orderLength = useSelector((state) => state.order.orders).length;

  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    getAllOrders(userData.id, getLocalData("user-info")?.userToken)
    .then(data => {
  
    dispatch( updateOrders(data))
    })
    .catch(err => console.log(err))
  }, [dispatch, userData.id]);

  
console.log(userData)
  return (
    <Row>
      <Col md={12}>
        <span className="header-1 header-profile">My Account</span>
      </Col>
      <Col md={12}>
        <div className="account-hero">
          <Row>
            <Col md={3} xs={12}>
             
            </Col>
            <Col md={7} xs={12} className="profile-block">
              <span className="account-name">{userData.name} {userData.age && (<span>({userData.age})</span>)} </span>
            </Col>
            <Col md={2} xs={12} className="profile-block">
              <Link to="/user/editprofile" className="btn btn-danger account-edit-btn">
                Edit Profile
              </Link>
            </Col>
          </Row>
          <div className="account-photo">
            <img alt="img" src={userData.pictureUrl} />
          </div>
          <div className="account-edit-btn-div d-none">
          <Link to="/user/editprofile" className="btn btn-danger account-edit-btn">
                Edit Profile
              </Link>
          </div>
        </div>
      </Col>
      <Col md={12}>
        <span className="acoount-sub-heading">Quick Links</span>
        <Row>
          <Col md={3} xs={6} className="tworem-p-r">
            <Link to="/user/orders/"  className="ql-parent">
            <div className="ql-icon-sec ">
                <Cart/>
                
                </div>
                <div className="ql-name-sec">
                <span className="ql-name-sec-h">Orders</span>
                  <span className="ql-name-sec-t">{orderLength}</span>
                </div>
                <div className="ql-para-se">
                <span className="ql-name-sec-p">Last order delivered</span>
                
                </div>
            </Link>
          </Col>
          <Col md={3} xs={6}  className="tworem-p-l">
              <Link  to="/wishlist" className="ql-parent">
                <div className="ql-icon-sec ">
                  <Wish/>
                </div>
                <div className="ql-name-sec">
                <span className="ql-name-sec-h">Wishlist</span>
                  <span className="ql-name-sec-t">{noOfProductsInWishlist} items</span>
                </div>
                <div className="ql-para-se">
                <span className="ql-name-sec-p">Items you’d love to buy</span>
                
                </div>
              </Link>
          </Col>
          {/* <Col md={3}>
              <div className="ql-parent">
                <div className="ql-icon-sec ">
                <img alt="img" src={ql3}/>
                </div>
                <div className="ql-name-sec">
                <span className="ql-name-sec-h">Membership</span>
                  <span className="ql-name-sec-t">Starter</span>
                </div>
                <div className="ql-para-se">
                <span className="ql-name-sec-p">Upgrade to Premium</span>
                
                </div>
              </div>
          </Col>
          <Col md={3}>
              <div className="ql-parent">
                <div className="ql-icon-sec ">
                <img alt="img" src={ql4}/>
                </div>
                <div className="ql-name-sec">
                <span className="ql-name-sec-h">Notifications</span>
                <span className="ql-name-sec-t"></span>
                </div>
                <div className="ql-para-se">
                <span className="ql-name-sec-p">See your recent updates</span>
                
                </div>
              </div>
          </Col> */}
        </Row>
      </Col>
      <Col md={12}>
        <span className="acoount-sub-heading">Account Related</span>
        <Row>
        <Col md={3} xs={6} className="tworem-p-r">
              <Link to="/user/address/" className="othergrid-parent">
                <div className="og-icon-sec ">
               <Home/>
                </div>
                <div className="og-name-sec">
                <span className="ql-name-sec-h">My Addresses</span>
                </div>
                
              </Link>
          </Col>
          <Col md={3} xs={6} className="tworem-p-l">
          <Link  to="/user/createAddress" className="othergrid-parent">
                <div className="og-icon-sec ">
               
                <AddAddress/>
                </div>
                <div className="og-name-sec">
                <span className="ql-name-sec-h">Add Address</span>
                </div>
                
              </Link>
          </Col>
        </Row>
      </Col>
      <Col md={12}>
        <span className="acoount-sub-heading">Legal</span>
        <Row className="margin-for-cols">
        
          <Col md={3} xs={6}  className="tworem-p-l">
          <Link  to="/privacypolicy" className="othergrid-parent">
                <div className="og-icon-sec ">
                <Pp/>
                </div>
                <div className="og-name-sec">
                <span className="ql-name-sec-h">Privacy Policy</span>
                </div>
                
              </Link>
          </Col>
          <Col md={4} xs={12} >
          <Link  to="/termsconditions" className="othergrid-parent">
                <div className="og-icon-sec ">
                  <Tc/>
                </div>
                <div className="og-name-sec">
                <span className="ql-name-sec-h">Terms & Conditions</span>
                </div>
                
              </Link>
          </Col>
          
          <Col md={4} xs={12} >
          <button className="btn btn-danger btn-logout user-profile-logout" onClick={() => {
                localStorage.clear();
                dispatch(updateUser({}))
                navigate("/");
              }}>
              LOGOUT
              </button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Profile;
